export default __webpack_public_path__ + "static/social-estados-ranking_en-651e5aa92580c2d3d2f447a400bbd595.png";